$(document).ready(()=>{
  activeSelect()
  activeTab()
  changeTitle()
});

const activeSelect = () => {
  $('.select_wrapper select').on('focus', (e) => {
    $(e.currentTarget).parent('.select_wrapper').addClass('active')
  })
  $('.select_wrapper select').on('focusout', (e) => {
    $(e.currentTarget).parent('.select_wrapper').removeClass('active')
  })
}

const activeTab = () => {
  let tab = $('.select_wrapper select').val()
  $('.select_wrapper select').on('change', () => {
    tab = $('.select_wrapper select').val()
    $('.'+tab).siblings().hide()
    $('.'+tab).show()
  })
}

const changeTitle = () => {
  $('.select_wrapper select').on('change', () => {
    tab = $('.select_wrapper select').val()
    title = $('.'+ tab +' .title').text()
    $('.product_title').text(title)
  })
}